import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './otStyle.css';
import config from '../../config.json';
import OTLabel from './OTLabel';

const apiUrl = config.apiUrl;

const OTDelete = () => {
    const [overtimeDetails, setOvertimeDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const { overtimeId } = useParams();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchOvertimeData = async () => {

            setIsDisable(true);

            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Overtime/${overtimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch overtime data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setOvertimeDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching overtime data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchOvertimeData();
    }, []);

    const handleDelete = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Overtime/Delete/${overtimeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setErrorMessage('');
                setSuccessMessage(data.Message);
                setIsDisable(false);
                navigate('/overtime-list');
            }
        } catch (error) {
            setErrorMessage('Error deleting overtime');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
    } = overtimeDetails;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasStandard) ? (
                <>
                    <h3>Delete Overtime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleDelete}>
                        <div className="row mt-4">
                            <OTLabel label="Transaction ID" value={TransactionID} />
                            <OTLabel label="Transaction Date" value={TransactionDate} />
                            <OTLabel label="Employee" value={Employee.Name} />
                            <OTLabel label="Date Start" value={DateStart} />
                            <OTLabel label="Date End" value={DateEnd} />
                            <OTLabel label="Duration" value={Duration} />
                            <OTLabel label="Remarks" value={Remarks} />
                            <OTLabel label="Status" value={Status} />
                        </div>

                        <div className="mb-2">
                            <Link to="/overtime-list" className="btn btn-secondary me-2">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    disabled={isDisable}
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default OTDelete;
